export const fetchPipelineEventPageAction = 'fetchPipelineEventPageAction';
